import { gql } from "@apollo/client";

export const GET_LABEL_ASSIGNMENT = gql`
  query GetLabelAssignment(
    $status: String
    $breakdowns: [SalesTableReportV3BreakdownsFilterInput]
    $manualOverride: String
    $search: String
    $granularity: String
    $sort: SortInput
    $page: Int
    $perPage: Int
  ) {
    me {
      id
      labelAssignment(
        status: $status
        breakdowns: $breakdowns
        manualOverride: $manualOverride
        search: $search
        granularity: $granularity
        sort: $sort
        page: $page
        perPage: $perPage
      ) {
        adKey
        name
        status
        platform
        labels {
          key
          value
          isManualLabel
          canDelete
          resolutionOrder
        }
      }
    }
  }
`;

export const GET_LABEL_ASSIGNMENT_COUNT = gql`
  query GetLabelAssignmentCount(
    $status: String
    $breakdowns: [SalesTableReportV3BreakdownsFilterInput]
    $manualOverride: String
    $search: String
  ) {
    me {
      id
      campaignLabelAssignmentCount(
        status: $status
        breakdowns: $breakdowns
        manualOverride: $manualOverride
        search: $search
      )
      adsetLabelAssignmentCount(
        status: $status
        breakdowns: $breakdowns
        manualOverride: $manualOverride
        search: $search
      )
      adLabelAssignmentCount(
        status: $status
        breakdowns: $breakdowns
        manualOverride: $manualOverride
        search: $search
      )
    }
  }
`;
